/**
 * @generated SignedSource<<b8db4caebfb5787880a23f1810c7f9f6>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type LinkForecastTaskToTicketInput = {
  ticketId: string;
  forecastTaskId: string;
  csrfToken?: string | null;
  socketClientId?: string | null;
  clientMutationId?: string | null;
};
export type linkForecastTaskToTicketMutation$variables = {
  input: LinkForecastTaskToTicketInput;
};
export type linkForecastTaskToTicketMutation$data = {
  readonly linkForecastTaskToTicket: {
    readonly clientMutationId: string | null;
    readonly ticket: {
      readonly id: string;
      readonly " $fragmentSpreads": FragmentRefs<"LinkedTasksTab_ticket">;
    };
  } | null;
};
export type linkForecastTaskToTicketMutation = {
  variables: linkForecastTaskToTicketMutation$variables;
  response: linkForecastTaskToTicketMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "clientMutationId",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "linkForecastTaskToTicketMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "LinkForecastTaskToTicketPayload",
        "kind": "LinkedField",
        "name": "linkForecastTaskToTicket",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Ticket",
            "kind": "LinkedField",
            "name": "ticket",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "LinkedTasksTab_ticket"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "linkForecastTaskToTicketMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "LinkForecastTaskToTicketPayload",
        "kind": "LinkedField",
        "name": "linkForecastTaskToTicket",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Ticket",
            "kind": "LinkedField",
            "name": "ticket",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "aiSuggestedLinkedTaskIds",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "totalLinkedTaskMinutes",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Task",
                "kind": "LinkedField",
                "name": "linkedTasks",
                "plural": true,
                "selections": [
                  (v3/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "companyTaskId",
                    "storageKey": null
                  },
                  (v4/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "totalMinutesRegistered",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "estimateForecastMinutes",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "deadlineYear",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "deadlineMonth",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "deadlineDay",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "StatusColumnV2",
                    "kind": "LinkedField",
                    "name": "statusColumnV2",
                    "plural": false,
                    "selections": [
                      (v4/*: any*/),
                      (v3/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ProjectType",
                    "kind": "LinkedField",
                    "name": "project",
                    "plural": false,
                    "selections": [
                      (v3/*: any*/),
                      (v4/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Person",
                    "kind": "LinkedField",
                    "name": "assignedPersons",
                    "plural": true,
                    "selections": [
                      (v3/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "fullName",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "dbae75a7fc834ba456651e23676e326b",
    "id": null,
    "metadata": {},
    "name": "linkForecastTaskToTicketMutation",
    "operationKind": "mutation",
    "text": "mutation linkForecastTaskToTicketMutation(\n  $input: LinkForecastTaskToTicketInput!\n) {\n  linkForecastTaskToTicket(input: $input) {\n    clientMutationId\n    ticket {\n      id\n      ...LinkedTasksTab_ticket\n    }\n  }\n}\n\nfragment LinkedTasksTab_ticket on Ticket {\n  id\n  aiSuggestedLinkedTaskIds\n  totalLinkedTaskMinutes\n  linkedTasks {\n    id\n    companyTaskId\n    name\n    totalMinutesRegistered\n    estimateForecastMinutes\n    deadlineYear\n    deadlineMonth\n    deadlineDay\n    statusColumnV2 {\n      name\n      id\n    }\n    project {\n      id\n      name\n    }\n    assignedPersons {\n      id\n      fullName\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "bec0b7d5efef68df0b7021cc4056aaaf";

export default node;
